import ProfilesContextProvider, { ProfilesContext, useProfilesContext } from './ProfilesContext';
import { IProps as IUseProfilesProps } from './useProfiles';

export type { IUseProfilesProps };
export { ProfilesContext, useProfilesContext };
export default ProfilesContextProvider;
